import React, { useState, useEffect } from 'react'
import DashboardCharts from './components/DashboardCharts'
import DashboardStatisticCards from './components/DashboardStatisticCards'
import BaseConfig from 'general/constants/DomainConfig'
import { useHostname } from 'general/context/HostnameContext'
import { DashboardFooter } from './components/DashboardFooter'
import WarningNotAcceptedModal from 'features/Invoice/screens/ListInvoice/Components/WarningNotAcceptedModal'
import ViewInvoiceModal from 'features/Invoice/screens/ListInvoice/Components/ViewInvoiceModal'
import invoiceApi from 'api/invoiceApi'
import WarningNotAcceptedHelper from 'general/helpers/WarningNotAcceptedHelper'

function DashboardHomeScreen() {
  const hostname = useHostname()
  const [inforInvoice, setInforInvoice] = useState({ show: false, data: {} })
  const [warningNotAcceptedModal, setWarningNotAcceptedModal] = useState({
    show: false,
  })

  useEffect(() => {
    invoiceApi
      .getWarningNotAccepted({ all: true, page: 1, limit: 20 })
      .then((res) => {
        const rows = Array.isArray(res)
          ? res
          : res?.rows || res?.data || res?.invoices || res?.list || []
        const invoiceIds = res?.invoiceIds || res?.data?.invoiceIds || []
        if (WarningNotAcceptedHelper.shouldAutoShow(rows, invoiceIds)) {
          setWarningNotAcceptedModal({
            show: true,
          })
        }
      })
      .catch((err) => {
        console.error(
          'Error fetching warning not accepted invoices on Dashboard:',
          err,
        )
      })
  }, [])

  return (
    <div className="container-fluid px-5 pb-5">
      <div className="card card-custom py-5 relative">
        {/* card stat */}
        <DashboardStatisticCards />
        {/* Charts */}
        <DashboardCharts />
        {BaseConfig[hostname]?.footer?.isHadFooter && (
          <>
            <DashboardFooter
              content={BaseConfig[hostname]?.footer?.content}
              buildVersion={BaseConfig[hostname]?.buildVersion}
            />
          </>
        )}
      </div>

      <ViewInvoiceModal
        open={inforInvoice.show}
        onCancel={() => {
          setInforInvoice({
            show: false,
          })
        }}
        value={inforInvoice.data}
      />

      <WarningNotAcceptedModal
        open={warningNotAcceptedModal.show}
        filterDismissed
        onCancel={() => setWarningNotAcceptedModal({ show: false })}
        onViewInvoice={(record) => {
          setInforInvoice({
            show: true,
            data: record,
          })
        }}
      />
    </div>
  )
}

export default DashboardHomeScreen
